import React, { useEffect, useMemo, useState } from 'react'
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import axios from 'axios';
import { Box, Chip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

function Signitic() {

    const { selectedOrganization } = useOrganizationSelect();
      const [loading, setLoading] = useState(false);
    
      
    
      const [signiticUser, setSigniticUser] = useState([]);
     
      const fetchSigniticUser = async () => {
          try {
              setLoading(true);
    
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/signitic/users`);
                console.log(response.data)
                // Filter by selectedOrganization if it's not null
                let filteredData = response.data;
                if (selectedOrganization) {
                filteredData = response.data.filter(
                  (item) => item.organization.name === selectedOrganization
                );
                }
                setSigniticUser(filteredData);
              setLoading(false);
    
          } catch (error) {
              console.error('Error fetching organizations:', error);
          }
      };
    
      useEffect(() => {
        fetchSigniticUser();
      }, [selectedOrganization]);


          const columns = useMemo(
            () => [
              {
                id: 'signitic',
                columns: [
                  {
                    accessorKey: 'firstname',
                    header: 'Prénom',
                    size: 100,
                    filterVariant: 'autocomplete',
                  },
                  {
                    accessorKey: 'lastname',
                    header: 'Nom',
                    size: 100,
                    filterVariant: 'autocomplete',
                  },
                  {
                    accessorKey: 'email',
                    header: 'Email',
                    size: 100,
                    filterVariant: 'autocomplete',
                  },
                   {
                    accessorFn: (row) => row.organization.name || '',
                    id: 'organizationName',
                    header: 'Client',
                    size: 100,
                    filterVariant: 'autocomplete',
                  },
                  {
                    accessorFn: (row) => row.status ? "Actif" : "Inactif" ,
                    id: 'status',
                    header: 'Statut',
                    size: 40,
                      Cell: ({ row }) => (
                        row.original.status 
                        ? <Chip label="Actif" color="primary" size="small" />
                        : <Chip label="Inactif" color="default" size="small" />
                    ),
                    filterVariant: 'autocomplete',
                  },
                 
                 
                ],
              },
            ],
            [],
          );

           const table = useMaterialReactTable({
                columns,
                data: signiticUser ? signiticUser : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
                enableColumnFilterModes: true,
                enableColumnOrdering: true,
                enableGrouping: true,
                enableColumnPinning: true,
                enableFacetedValues: true,
                // enableRowSelection: true,
                initialState: {
                  density:"compact",
                  // showColumnFilters: true,
                  // showGlobalFilter: true,
                  columnPinning: {
                    left: ['mrt-row-expand', 'mrt-row-select'],
                    right: ['mrt-row-actions'],
                  },
                  pagination: {
                    pageSize: 50,
          
                  }
                },
                paginationDisplayMode: 'pages',
                positionToolbarAlertBanner: 'bottom',
                enableRowSelection: true,
                muiSearchTextFieldProps: {
                  size: 'small',
                  variant: 'outlined',
                },
                muiPaginationProps: {
                  color: 'secondary',
                  rowsPerPageOptions: [50, 100, 150],
                  shape: 'rounded',
                  variant: 'outlined',
                },
              });




return (
    <Box>
        <Typography variant="h6" my={1} mb={3}>Utilisateurs Signitic</Typography>
                  <MaterialReactTable table={table} />
        
       
    </Box>
)
}

export default Signitic